import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { usePlatformAuth } from '../../context/PlatformAuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { ShieldCheck, Eye, EyeOff } from 'lucide-react';

const PlatformLogin = () => {
  const navigate = useNavigate();
  const { login } = usePlatformAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome to Platform Admin!');
      navigate('/platform/dashboard');
    } catch (err) {
      toast.error(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4" data-testid="platform-login-page">
      <Card className="w-full max-w-md border-slate-700 bg-slate-800" data-testid="platform-login-card">
        <CardHeader className="text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <ShieldCheck className="h-10 w-10 text-indigo-400" />
          </div>
          <CardTitle className="text-2xl text-white" data-testid="platform-login-title">Platform Admin</CardTitle>
          <CardDescription className="text-slate-400">Ariskool Service Provider Console</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="platform-login-form">
            <div className="space-y-2">
              <Label className="text-slate-300">Email</Label>
              <Input
                type="email"
                placeholder="superadmin@ariskool.in"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-500"
                data-testid="platform-email-input"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-slate-300">Password</Label>
              <div className="relative">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-500 pr-10"
                  data-testid="platform-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-200"
                >
                  {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
              </div>
            </div>
            <Button type="submit" className="w-full h-12 bg-indigo-600 hover:bg-indigo-700" disabled={loading} data-testid="platform-login-btn">
              {loading ? 'Signing in...' : 'Sign In to Console'}
            </Button>
          </form>
          <p className="text-xs text-slate-500 text-center mt-5">
            <Link to="/login" className="text-indigo-400/70 hover:text-indigo-300 transition-colors" data-testid="back-to-school-login-link">Back to School Login</Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlatformLogin;
